module.exports = __webpack_public_path__ + "img/namsan_thumbnail.735edfaf.jpg";